import React, { useEffect, useRef, useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";

export default function ExpandableComponent({
  children,
  Title = "Title",
  SubTitle = "SubTitle",  
  defaultValue,
}) {
  const [expanded, setExpanded] = useState(defaultValue);
  const expandableRef = useRef(null);
  const toggleExpanded = () => {
    setExpanded(!expanded);
  };
  const handleClickOutside = (event) => {
    if (
      expandableRef.current &&
      !expandableRef.current.contains(event.target)
    ) {
      setExpanded(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div className={`ExpandableComponent w-full`}>
      <button
        className={`expandable-header cursor-pointer flex items-center justify-start px-1 h-auto border w-full p-[2px] bg-gray-100 border-gray-300`}
        onClick={toggleExpanded}
      >
        <button className={`text-black w-full text-left flex flex-col gap-[2px] font-medium tracking-wide`}>
          {Title}
          <span className="text-xs text-gray-600">{SubTitle}</span>
        </button>
        <button className="flex items-center">
          {expanded ? (
            <MdKeyboardArrowDown className={`text-2xl text-gray-600`} />
          ) : (
            <MdKeyboardArrowRight className={`text-2xl text-gray-600`} />
          )}
        </button>
      </button>
      {expanded && (
        <div className={`expandable-content pt-1 relative w-full`}>
          {children}
        </div>
      )}
    </div>
  );
}
